import { FC } from "react";

import {
  IAiConversationDetailsDrawerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { AiConversationDetailsDrawer } from "./ai-conversation-details.drawer";

export const AiConversationDetailsDrawerWrapper: FC<
  IAiConversationDetailsDrawerProps & IInjectedDrawerProps
> = ({ rawReasoning, onCloseDrawer }) => (
  <AiConversationDetailsDrawer
    rawReasoning={rawReasoning}
    onClose={onCloseDrawer}
  />
);
